import React from 'react';

import { useLocalization } from 'common/providers/LocaleProvider';
import { transformOriginalImageUrl } from 'common/utils/cdn/image';
import AttachedPicture from './AttachedPicture';

interface PictureProps {
  src: string;
  size: number;
  index: number;
  onClick: (index: number) => void;
}

const Picture = ({ src, size, index, onClick }: PictureProps) => {
  const { t } = useLocalization();
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    onClick(index);
  };
  const pictureSrc = transformOriginalImageUrl(src, { width: size });

  return (
    <AttachedPicture
      as="button"
      data-testid="picture"
      backgroundImage={`url(${pictureSrc})`}
      width={size}
      height={size}
      onClick={handleClick}
      aria-label={`${t('h24_images_attached')} (${index + 1}), ${t('h24_open_image_gallery')}`}
    />
  );
};

export default Picture;
